<script setup lang="ts">
const paginationContext = usePaginationContext();
const props = defineProps<{
  listAriaLabel: string;
  loading: boolean;
  transitionName: string;
}>();

const attrs = useAttrs();
const focusAnchor = ref<HTMLElement | null>(null);
const list = ref<HTMLElement | null>(null);
const userHasUsedPagination = ref(false);

watch(
  () => props.loading,
  async (newVal, oldVal) => {
    if (oldVal === true && newVal === false) {
      await nextTick();
      list.value?.scrollIntoView({ behavior: 'smooth' });
    }
  }
);
</script>

<template>
  <span
    :id="`${paginationContext.paginationId.value}-focus-anchor`"
    ref="focusAnchor"
    tabindex="-1"
    class="sr-only"
    aria-hidden="true"
  >
    {{ $t('Pagination.AriaFocusMovedToStartOfList') }}
  </span>
  <a
    v-if="userHasUsedPagination"
    :href="`#${paginationContext.paginationId.value}`"
    class="sr-only"
  >
    {{ $t('Pagination.SkipToPagination') }}
  </a>
  <ul
    ref="list"
    :aria-label="listAriaLabel"
    v-bind="attrs"
  >
    <TransitionGroup name="list">
      <slot></slot>
    </TransitionGroup>
  </ul>
</template>
